<template>
    <div class="verify__wrap">
        <template v-if="pageLoading">
            <PageSpinner />
        </template>
        <template v-else-if="pageErr">
            <EmptyPage 
                state="error_custom" 
                btn-state="custom"
                title="An error occurred" 
                class="verify__wrap__empty"
                :subtitle="pageErrMsg"
            >
                <template #button>
                    <BaseButton 
                        :label="pageErr === 'retry_limit_exceeded' ? 'Go to login page' : 'Retry logout'" 
                        :icon-name="pageErr === 'retry_limit_exceeded' ? 'chevrons-left' : 'refresh'" 
                        icon-width="16px" 
                        prefix-icon 
                        @submit="retryLogout"
                    />
                </template>
            </EmptyPage>
        </template>
    </div>
</template>

<script>
import { PageSpinner, EmptyPage, BaseButton } from "@/components/ui/index";

export default {
    name: "LogoutPage",

    components: {
        PageSpinner,
        EmptyPage,
        BaseButton,
    },

    data() {
        return {
            pageLoading: true,
            pageErr: "",
            retryCount: 0,
            btnDisabled: false,
        };
    },

    computed: {
        pageErrMsg() {
            switch (this.pageErr) {
            case "page_error":
                return "Unable to log out. Please, click the reload button";
            case "retry_limit_exceeded":
                return "Retry limit for logout exceeded. Please try again later.";
            default:
                return "An unexpected error occurred. Please try again.";
            }
        },
    },

    watch: {
        retryCount(newVal) {
            if (newVal >= 3) {
                this.pageErr = "retry_limit_exceeded";
            }
        },
    },

    async mounted() {
        await this.retryLogout();
    },

    methods: {
        async retryLogout() {
            if (this.retryCount >= 3) {
                this.$router.push("/auth/login");
                return;
            }

            try {
                this.pageErr = "";
                this.retryCount = this.retryCount + 1;
                this.pageLoading = true;

                await this.$store.dispatch("auth/signOut");
                
                localStorage.clear();
                sessionStorage.clear();
                
                if (this?.$socket && typeof this.socket === "function") {
                    this.$socket("disconnect", (reason) => {
                        console.warn("App is being closed:", reason);
                    });
                    this.$socket.off("disconnect", () => {});
                }

                this.$toast.success("Logout successful");
                this.$router.push("/auth/login");
            } catch (error) {    
                console.error({ logout: error });
                            
                this.pageErr = "page_error";;
            } finally {
                this.pageLoading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.verify__wrap {
    height: 100vh;

    &__empty {
        margin: 6rem auto;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: auto;
    }
}
</style>